import React from 'react'

import { title, subtitle, seeMore } from './data.json'
import { Container, Title, Subtitle, SeeMore, SeeMoreIcon, SeeMoreContainer } from './styles'

const NewPlaces = () => (
  <Container>
    <header>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </header>
    <SeeMoreContainer>
      <SeeMore>{seeMore}</SeeMore>
      <SeeMoreIcon icon="right-arrow" width="8" height="13" viewBox="0 0 8 13" />
    </SeeMoreContainer>
  </Container>
)

export default NewPlaces



// WEBPACK FOOTER //
// ./src/app/pages/ec/DashboardResume/newPlaces/index.js